<template>
  <section id="contactMe">
    <div class="h-screen">
      <div class="h-full flex flex-col justify-center">
        <div class="text-center mb-10 -mt-36 exp">
          <p>***</p>
          <p
            data-aos="fade-right"
            data-aos-offset="300"
            data-aos-duration="1000"
            data-aos-easing="ease-in-sine"
            class="scroll__sub__headers font-bold"
          >
            Contact me
          </p>
        </div>
        <div
        :class="[$root.isDarkMood ? 'text-slate-50' : 'text-gray-700']"
          class="
            space-y-4
            md:space-y-0
            flex flex-col
            md:flex-row
            items-center
            justify-center
            md:space-x-4
          "
        >
          <div
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-anchor-placement="bottom-bottom"
            :class="[$root.isDarkMood ? 'menu_bar_bg' : 'dark_menu_bar_bg']"
            class="w-64 p-5 rounded-lg flex flex-col items-center space-y-4"
          >
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              ></path>
            </svg>
            <p>Email</p>
            <p class="text-gray-400">yellyint48@gmail.com</p>
            <div class="flex items-center cursor-pointer seeMore space-x-2">
              <address>
                <a
                  href="mailto:yellyint48@gmail.com"
                  class="text-sm text-sky-600"
                  >Write me</a
                >
              </address>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 w-4 text-sky-600 transition-all see_more_cta"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
            </div>
          </div>
          <div
            data-aos="fade-up"
            data-aos-duration="2000"
            data-aos-anchor-placement="bottom-bottom"
            :class="[$root.isDarkMood ? 'menu_bar_bg' : 'dark_menu_bar_bg']"
            class="w-64 p-5 rounded-lg flex flex-col items-center space-y-4"
          >
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              ></path>
            </svg>
            <p>Messenger</p>
            <p class="text-gray-400">m.me/pkthedeveloper</p>
            <div class="flex items-center cursor-pointer seeMore space-x-2">
              <a
                href="https://www.messenger.com/t/102298562238897/?messaging_source=source%3Apages%3Amessage_shortlink"
                class="text-sm text-sky-600"
                >Message me</a
              >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 w-4 text-sky-600 transition-all see_more_cta"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
            </div>
          </div>
          <div
            data-aos="fade-up"
            data-aos-duration="3000"
            data-aos-anchor-placement="bottom-bottom"
            :class="[$root.isDarkMood ? 'menu_bar_bg' : 'dark_menu_bar_bg']"
            class="w-64 p-5 rounded-lg flex flex-col items-center space-y-4"
          >
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
              ></path>
            </svg>
            <p>Phone</p>
            <p class="text-gray-400">09 779 048 944</p>
            <div  @click="copy" class="flex items-center cursor-pointer seeMore space-x-2">
              <button id="btnCopy" class="text-sm text-sky-600">
                Copy Number
              </button>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 w-4 text-sky-600 transition-all see_more_cta"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Swal from "sweetalert2";
export default {
  methods: {
    copy() {
      if (navigator.clipboard.writeText("09 779 048 944")) {
        Swal.fire('you have just copied my number.')
      }
    },
  },
};
</script>

<style>
.swal2-title{
  font-size: 1em;
}
</style>